export default "__VITE_ASSET__B0B0ANoC__"